app.controller("AddSessionController", [
    "$scope", "Session", "Lecturer", "StaticData", "$stateParams", "$uibModalInstance", "activation", "toastr",
    function ($scope, Session, Lecturer, StaticData, $stateParams, $uibModalInstance, activation, toastr) {
        $scope.lecturer = "";
        $scope.title = "";
        $scope.activation = activation;
        $scope.duration = '';
        $scope.isPushed = false;

        StaticData.getItemsByKey("session_types").then(function (types) {
            $scope.types = types;
            $scope.sessionType = types[0]
        });

        $scope.getLecturers = function (query) {
            if (query.length < 2) {
                return [];
            }
            return Lecturer.list({query: query}).then(function (data) {
                return data.docs;
            });
        };

        $scope.saveSession = function () {
            if (!$scope.title) return toastr.error('', 'გთხოვთ მიუთითოთ ჯგუფის სახელი');
            if (!$scope.chosenLecturer) return toastr.error('', 'გთხოვთ მიუთითოთ ლექტორი');
            if (!$scope.duration) return toastr.error('', 'გთხოვთ მიუთითოთ საათების რაოდენობა');
            if (!$scope.minStudents) return toastr.error('', 'გთხოვთ მიუთითოთ სტუდენტების მინიმალური რაოდენობა');
            if (!$scope.maxStudents) return toastr.error('', 'გთხოვთ მიუთითოთ სტუდენტების მაქსიმალური რაოდენობა');
            else{
                $scope.isPushed = true;
                Session.save({
                    lecturer: $scope.chosenLecturer._id,
                    title: $scope.title,
                    sessionType: $scope.sessionType._id,
                    subjectActivation: $scope.activation._id,
                    subjectWrapper: $scope.activation.subjectWrapper,
                    subject: $scope.activation.subject._id,
                    minStudents: $scope.minStudents,
                    maxStudents: $scope.maxStudents,
                    duration: $scope.duration
                }).then(function (result) {
                    toastr.success('ჯგუფი დამატებულია');
                    $uibModalInstance.close();
                }).finally(function () {
                    $scope.isPushed = false;
                })
            }
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);